import { CmtsMasterDataCrudShell } from "../components/master-data/index.js";

export function CmtsComplaintCategoryPage() {
  return <CmtsMasterDataCrudShell entityKey="complaint-category" />;
}

export default CmtsComplaintCategoryPage;
